jQuery(document).ready(function($) {
  var ajaxCart = {
    formClass: '.js-cart-form',
    wrapperClass: '.js-cart-wrapper',
    cartCountClass: '.js-cart-count',
    quantityClass: '.js-cart-quantity',
    removeClass: '.js-cart-remove',
    regularPriceClass: '.js-price-regular',
    salePriceClass: '.js-price-sale',
    updatePrices(value) {
      var wrapperElement = $(this.wrapperClass);
      var regularPrice = wrapperElement.find(this.regularPriceClass);
      var unitPrice = wrapperElement.find('[data-unit-price-amount]');
      if(!unitPrice.text()) {      
        var salePrice = wrapperElement.find(this.salePriceClass);
        if(regularPrice.length && value) {
          var regularPriceInt = parseFloat(regularPrice.data('regular-price').replace('$', '')).toFixed(2);
          regularPrice.text('$' + parseFloat(regularPriceInt * value).toFixed(2) + ' CAD');
        }
        if(salePrice.length && value) {
          var salePriceInt = parseFloat(salePrice.data('sale-price').replace('$', '')).toFixed(2);
          salePrice.text('$' + parseFloat(salePriceInt * value).toFixed(2) + ' CAD');
        }
      } else {
        var unitPriceInt = parseFloat(unitPrice.html().replace('$', '')).toFixed(2);
      	regularPrice.text('$' + parseFloat(unitPriceInt * value).toFixed(2) + ' CAD');
      }
    },
    handleMinus(quantityInput) {
      var quantityInputValue = quantityInput.val();
      var newValue = parseInt(quantityInputValue) - 1;
      if(newValue > 0) {
        if (!isNaN(quantityInputValue) && quantityInputValue > 0) {
          quantityInput.val(newValue);
          quantityInput.trigger('keydown');
          this.updatePrices(newValue);
        } else {
          quantityInput.val(parseInt(0));
        }
      }
    },
    handlePlus(quantityInput) {
      var quantityInputValue = quantityInput.val();
      var newValue = parseInt(quantityInputValue) + 1;
      quantityInput.val(newValue);
      quantityInput.trigger('keydown');
      this.updatePrices(newValue);
    },
    handleChange(quantityInput) {
      var quantityInputValue = quantityInput.val();
      this.updatePrices(quantityInputValue);
    },
    replaceQuantityFields() {
      var self = this;
      var quantityFields = $(this.quantityClass);

      quantityFields.each(function(index, quantity) {
        var quantityValue = $(quantity).val();
        var quantityId = $(quantity).attr('id');
        var quantityName = $(quantity).attr('name');

        var quantityWrapper = $('<div class="quantity js-quantity"></div>');
        var minusButton = $('<button class="quantity__button quantity__button--minus js-quantity-minus"></button>');
        var quantityInput = $('<input type="text" name="' + quantityName + '" value="' + quantityValue + '" id="' + quantityId + '" class="quantity__input js-quantity-field" data-cart-item-quantity>');
        var plusButton = $('<button class="quantity__button quantity__button--plus js-quantity-plus"></button>');

        $(quantity).replaceWith(quantityWrapper);
        quantityWrapper.append(minusButton);
        quantityWrapper.append(quantityInput);
        quantityWrapper.append(plusButton);

        minusButton.click(function(event) {
          event.preventDefault();
          self.handleMinus(quantityInput);
        });

        plusButton.click(function(event) {
          event.preventDefault();
          self.handlePlus(quantityInput);
        });

        quantityInput.keydown(function(event) {
          self.handleChange(quantityInput)
        });
      
        $('.option-value-input').on('focus', function() {
          var quantityInputValue = quantityInput.val();
          quantityInput.val(1);
          self.updatePrices(quantityInputValue);
        });
      });
    },
    init() {
      var self = this;
      var quantity = $(this.quantityClass);
      var removeLink = $(this.removeClass);

      if(quantity.length > 0) {
        this.replaceQuantityFields();
      }
    }
  };

  ajaxCart.init();
  
  $(document).ajaxComplete(function() {
    ajaxCart.init();
  });
});